import React from 'react';

import { Row } from '~components/table-view-v3';

interface ComponentProps {
  row: Row;
}

const StatusBadge: React.FC<ComponentProps> = ({ row }) => {
  const { status } = row || {};
  const { colour, name } = status || {};
  const colorHex = colour ? `#${colour}` : undefined;
  return <span style={{ color: colorHex, fontWeight: 'bold' }}>{name || ''}</span>;
};

export default StatusBadge;
